export const DEMO_MEDIA_ROUTES = {
  // Backend: GET api/demo/session/<str:session_id>/media/ — API_BASE_URL
  // already carries the `/api` segment, same as every sibling route in
  // apis/*, so it's omitted here.
  GET_SESSION_MEDIA: sessionId => `/demo/session/${sessionId}/media`,
};
